import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ServiceTile from '../components/ServiceTile';
import servicesData from '../data/services.json';
import seoData from '../data/seo.json';

const Services = () => {
    return (
        <div className="pt-36 container mx-auto px-4 mb-20">
            <SEO page="services" />
            
            <div className="text-center mb-16">
                <h1 className="text-4xl font-bold mb-4 animate-fade-in opacity-0">{servicesData.pageTitle}</h1>
                <p className="text-text-light max-w-2xl mx-auto animate-fade-in opacity-0 animation-delay-100">
                    {servicesData.pageDescription}
                </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {servicesData.services.map((service, index) => (
                    <ServiceTile
                        key={service.id}
                        title={service.title}
                        description={service.description}
                        index={index}
                    />
                ))}
            </div>

            {/* CTA Section */}
            <div className="mt-16 glass-panel p-10 text-center animate-fade-in opacity-0">
                <h2 className="text-2xl font-bold mb-4 text-text-dark">Ready to Get Started?</h2>
                <p className="text-text-light mb-6 max-w-xl mx-auto">
                    Contact Calgary's trusted plumbing and heating experts. Available 24/7 for emergencies.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                    <a 
                        href={`tel:${seoData.business.phone.replace(/[^0-9]/g, '')}`}
                        className="glass-button px-8 py-4 inline-flex items-center justify-center"
                    >
                        Call {seoData.business.phone}
                    </a>
                    <Link to="/contact">
                        <button className="glass-panel px-8 py-4 text-primary-blue font-bold hover:bg-white/50 transition-colors !rounded-2xl h-full">
                            Request a Quote
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Services;
